<template>
  <div class="package-edit">
    <router-link :to="{ name: 'AdminDashboard' }">&larr; Kembali ke Paket Tes</router-link>
    <h1>Edit Paket Tes</h1>

    <div v-if="isLoading" class="loading">Memuat data...</div>
    <div v-else-if="packageData" class="card">
      <form @submit.prevent="updatePackage">
        <div class="form-group">
          <label for="pkg-name">Nama Paket</label>
          <input id="pkg-name" v-model="packageData.name" required />
        </div>
        <div class="form-group">
          <label for="pkg-code">Kode Akses</label>
          <input id="pkg-code" v-model="packageData.access_code" required />
        </div>
        <div class="form-group">
          <label for="pkg-template">Template Psikogram</label>
          <select id="pkg-template" v-model="packageData.psychogram_template_id">
            <option :value="null">-- Tanpa Template --</option>
            <option v-for="template in templates" :key="template.id" :value="template.id">
              {{ template.name }}
            </option>
          </select>
        </div>
        <div class="form-group" v-if="authStore.user && !authStore.user.gerai_id">
          <label for="package-gerai">Pilih Gerai (Opsional)</label>
          <select id="package-gerai" v-model="packageData.gerai_id">
            <option :value="null">-- Tidak Terikat Gerai --</option>
            <option v-for="gerai in allGerai" :key="gerai.id" :value="gerai.id">
              {{ gerai.name }}
            </option>
          </select>
        </div>
        <div class="form-group checkbox-group">
          <input id="pkg-active" v-model="packageData.is_active" type="checkbox" />
          <label for="pkg-active">Aktif</label>
        </div>
        <button type="submit" :disabled="isSaving">
          {{ isSaving ? 'Menyimpan...' : 'Simpan Perubahan' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiClient from '@/services/api.js';

const route = useRoute();
const router = useRouter();
const packageId = route.params.id;

// State
const packageData = ref(null);
const templates = ref([]);
const isLoading = ref(true);
const isSaving = ref(false);

const allGerai = ref([]);
// Fungsi untuk mengambil daftar gerai
const fetchAllGerai = async () => {
  try {
    const response = await apiClient.get('/admin/gerai/');
    allGerai.value = response.data;
  } catch (err) {
    console.error("Gagal memuat daftar gerai.", err);
  }
};

// Fetch data awal (detail paket & daftar semua template)
const fetchData = async () => {
  isLoading.value = true;
  try {
    const [pkgRes, tplRes] = await Promise.all([
      apiClient.get(`/admin/packages/${packageId}`),
      apiClient.get('/admin/psychogram-templates/')
    ]);
    packageData.value = pkgRes.data;
    templates.value = tplRes.data;
  } catch (error) {
    console.error("Gagal memuat data:", error);
  } finally {
    isLoading.value = false;
  }
};

// Fungsi untuk menyimpan perubahan
const updatePackage = async () => {
  isSaving.value = true;
  try {
    // Siapkan payload yang bersih
    const payload = {
      name: packageData.value.name,
      access_code: packageData.value.access_code,
      is_active: packageData.value.is_active,
      // Kirim null jika tidak ada template yang dipilih
      psychogram_template_id: packageData.value.psychogram_template_id || null,
      gerai_id: packageData.value.gerai_id || null, // Pastikan ini juga ada
    };

    // --- TAMBAHKAN LOG DI SINI UNTUK DEBUGGING ---
    console.log("Mengirim payload UPDATE paket:", payload);

    await apiClient.put(`/admin/packages/${packageId}`, payload);
    alert("Paket tes berhasil diperbarui!");
    router.push({ name: 'AdminDashboard' });
  } catch (error) {
    alert("Gagal memperbarui paket tes.");
    console.error(error);
  } finally {
    isSaving.value = false;
  }
};

onMounted(() => {
  // PANGGIL FUNGSI DI SINI AGAR DROPDOWN GERAI TERISI
  fetchAllGerai();
  fetchData();

  // Jika Anda punya logika lain untuk memuat data paket saat edit,
  // biarkan di sini.
  // if (isEditMode) {
  //   loadPackageData(route.params.id);
  // }
});
</script>

<style scoped>
.package-detail { max-width: 960px; margin: auto; padding: 20px; }
h1, h2 { margin-top: 0; }
.page-header { margin-bottom: 20px; }
.header-meta { display: flex; gap: 20px; color: #555; margin-top: 10px; }
.badge { padding: 4px 10px; border-radius: 12px; font-size: 0.8em; font-weight: 600; }
.badge.active { background-color: #d4edda; color: #155724; }
.badge.inactive { background-color: #f8d7da; color: #721c24; }
.card { margin-top: 20px; padding: 20px; border-radius: 8px; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }

/* Daftar Tes */
.test-list { display: flex; flex-direction: column; gap: 10px; }
.test-item { display: flex; justify-content: space-between; align-items: center; padding: 15px; border: 1px solid #eee; border-radius: 6px; }
.test-info { display: flex; flex-direction: column; gap: 5px; }
.test-info small { color: #777; }
.remove-btn { background-color: #e74c3c; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 0.9em; }

/* Form Tambah Tes */
.add-test-form { display: flex; gap: 10px; }
.add-test-form select { flex-grow: 1; padding: 10px; border-radius: 4px; border: 1px solid #ccc; }
.add-test-form button { padding: 10px 15px; border-radius: 4px; border: 1px solid transparent; background-color: #1abc9c; color: white; cursor: pointer; }
.add-test-form button:disabled { background-color: #95a5a6; cursor: not-allowed; }
.error { color: red; }
</style>